import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiErrorMessage(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errFrom(e) {
  return apiErrorMessage(e?.response?.data?.detail) || e?.message || "Network error";
}

export function absUrl(relOrAbs) {
  if (!relOrAbs) return "";
  if (/^https?:\/\//.test(relOrAbs)) return relOrAbs;
  return `${BACKEND_URL}${relOrAbs}`;
}
